import index from "./goPoints.vue";
export default index;
